import { ISubCategoria } from "../../../../Interfaces/Geral/GestaoDeCadastro/SubCategoria/SubCategoriaInterfaces";
import { ISubCategoria as ISubCategorias } from "../../../../Interfaces/Geral/SubCategoria/SubCategoriaInterface";
import Axios from "../../../Config/API";
import Service from "../../../Service";

export async function ListarSubCategoriaService(
    IDCategoria: number | number[],
    IDProduto?: number,
    categoriaAtendimento?: string
) {
    return Service(
        Axios.get<Array<ISubCategoria>>(
            `/home/subcategoria/listarsubcategorias?IDCategoria=${IDCategoria}${
                IDProduto ? `&IDProduto=${IDProduto}` : ""
            }&CategoriaAtendimento=${categoriaAtendimento}`
        )
    );
}

export async function ListarVariasSubCategoriasService(
    ID_PRODUTO: string | number | number[],
    ID_CATEGORIA_ATENDIMENTO: number | number[]
) {
    return Service(
        Axios.post<Array<ISubCategoria>>(
            `/home/subcategoria/listarvariassubcategorias`,
            {
                ID_PRODUTO,
                ID_CATEGORIA_ATENDIMENTO,
            }
        )
    );
}

export async function CadastrarSubCategoriaService(
    requestBody: ISubCategorias
) {
    return Service(
        Axios.post(`/home/subcategoria/cadastrarsubcategorias`, requestBody)
    );
}

export async function AtualizarSubCategoriaService(requestBody: ISubCategoria) {
    return Service(
        Axios.put(
            `/home/subcategoria/atualizarconfigcobrancaregua`,
            requestBody
        )
    );
}

export async function DeletarSubCategoriaService(idSubCategoria: number) {
    return Service(
        Axios.delete(
            `/home/subcategoria/deletarconfigcobrancaregua?idSubcategoriaAtendimento=${idSubCategoria}`
        )
    );
}
